module.exports = __webpack_public_path__ + "static/media/submitOrder.b0114b97.png";